import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-318">
      <SEO title="About | KittyPot — No More Chasing Friends for Money" description="The story behind KittyPot, a shared expense and settlement tracker that helps groups track shared expenses, split costs fairly, and see the simplest way to settle up." ogTitle="About KittyPot" ogDescription="Track shared expenses, split costs fairly, and see the simplest way to settle up." path="/about" data-id="element-319" />
      <Navbar data-id="element-320" />
      <main className="pt-32 pb-24" data-id="element-321">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-322">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-323">
            About KittyPot
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-324">
            <p data-id="element-325">
              KittyPot started with a simple question: how do groups keep things
              fair when one person pays and everyone else needs to settle up?
            </p>
            <p data-id="element-326">
              The idea was sparked during the pandemic, during a family
              conversation about organising a kitty for a bike tour. With
              contactless replacing cash, group money was becoming increasingly
              awkward to manage.
            </p>
            <p data-id="element-327">
              KittyPot was built to make shared expenses clearer, fairer and
              easier to settle — without the awkward chasing afterwards.
            </p>
            <p data-id="element-328">
              The current MVP focuses on tracking expenses and manual settlement
              first. This lets us validate the real user problem before adding
              more complex payment features later.
            </p>
            <p className="font-medium mt-8" data-id="element-329">Benjamin Elliott, Founder</p>
          </div>
        </div>
      </main>
      <Footer data-id="element-330" />
    </div>;
}